import React, { lazy, Suspense, useEffect, useState } from "react";
import TaxFormImg1 from "@/assets/TaxForm/waggex-compliance-management-software-dashboard-india.webp";
import TaxFormImgmobile from "@/assets/TaxForm/waggex-compliance-management-software-dashboard-india.webp";

const CustomerReviews = lazy(
  () => import("../components/payrolewebapp/CustomerReviews"),
);

const ComparisonTable = lazy(
  () => import("../components/payrolewebapp/ComparisonTable"),
);

const HomeFaq = lazy(() => import("./HomeFaq"));

const AppDownloadCard = lazy(
  () => import("../components/common/AppDownloadCard"),
);

const PayrollBanner = lazy(() => import("../components/common/PayrollBanner"));

const ModernizeHR = lazy(() => import("../components/common/ModernizeHR"));
import { Play } from "lucide-react";
import StatsSection from "../components/common/StatsSection";
import { Helmet } from "react-helmet-async";
import TutorialVideos from "../components/common/TutorialVideos";
import axios from "axios";
import TutorialVideosMain from "../components/common/TutorialVideosMain";
import SEO from "../components/SEO";
import { useHrmsCounts } from "../hooks/useHrmsCounts";
import { useInView } from "react-intersection-observer";
const taxItems = [
  {
    title: "Employee Compliance Records",
    description:
      "Store and manage employee compliance records, declarations, and statutory documents from one centralized dashboard for better accessibility and organization.",
    icon: (
      <div className="text-[#10324F]">
        <Play fill="currentColor" size={16} aria-hidden="true" />
      </div>
    ),
  },
  {
    title: "PF & ESI Management",
    description:
      "Maintain PF and ESI records in a structured system that helps businesses organize compliance-related employee information efficiently.",
    icon: (
      <div className="text-[#10324F]">
        <Play fill="currentColor" size={16} aria-hidden="true" />
      </div>
    ),
  },
  {
    title: "Payroll Compliance",
    description:
      "Organize payroll-related compliance forms, records, and documentation in one place for easier tracking and management.",
    icon: (
      <div className="text-[#10324F]">
        <Play fill="currentColor" size={16} aria-hidden="true" />
      </div>
    ),
  },
  {
    title: "Audit & Document Access",
    description:
      "Access compliance documents instantly during audits, inspections, and internal reviews with centralized digital record management.",
    icon: (
      <div className="text-[#10324F]">
        <Play fill="currentColor" size={16} aria-hidden="true" />
      </div>
    ),
  },
];
const companystepsFeatures = [
  // ROW 1
  {
    id: 1,
    title: "Create Account",
    desc: "Sign up, log in, and access your Waggex dashboard to begin setting up your HR and payroll system.",
  },
  {
    id: 2,
    title: "Company Setup",
    desc: "Add company details, branches, locations, departments, and attendance policies from one place.",
  },
  {
    id: 3,
    title: "Shift Management",
    desc: "Create work shifts, define working hours, break timings, and assign employees to schedules.",
  },

  // ROW 2
  {
    id: 4,
    title: "Leave Policy",
    desc: "Configure leave types, annual leave balances, approval workflows, and employee leave rules.",
  },
  {
    id: 5,
    title: "Events & Holidays",
    desc: "Add national, state, festival, and company holidays to maintain an accurate attendance calendar.",
  },
  {
    id: 6,
    title: "Employee Onboarding",
    desc: "Add employees, salary structures, documents, contact information, and mobile app access.",
  },

  // ROW 3
  {
    id: 7,
    title: "Attendance Setup",
    desc: "Enable manual, selfie-based, FaceLens, QR code, geo-location, or kiosk attendance tracking.",
  },
  {
    id: 8,
    title: "Payroll Generation",
    desc: "Review attendance, calculate salaries, process payroll, and generate professional payslips instantly.",
  },
  {
    id: 9,
    title: "Reports & Compliance",
    desc: "Access payroll reports, attendance summaries, statutory records, and employee data insights.",
  },
];
const Faqs1 = [
  {
    title: "Where do I start if I am new to Waggex?",
    content:
      "Start with Waggex Setup Guide Part 1 on the Waggex YouTube channel. It covers the full platform walkthrough including account setup, attendance configuration, and payroll generation. Parts 2 through 5 cover individual features in more detail.",
  },
  {
    title: "Is My Data Secure With The Waggex Payroll Web App?",
    content:
      "Yes. The Waggex App enforces Grade SSL Encryption, Multi-Factor Authentication, and Encrypted Backups to protect all business data. Payroll records, employee information, and attendance logs are stored securely with role-based access controls so only authorised users can view or make changes.",
  },
  {
    title: "Can I Create More Than One Company On Waggex?",
    content:
      "Yes. Waggex supports multiple company accounts under a single login. Each company operates independently with its own employees, payroll settings, and attendance configurations. Switch between accounts from the same dashboard without logging out.",
  },
];

const Faqs2 = [
  {
    title: "How long does it take to set up Waggex?",
    content:
      "Most businesses complete the initial setup in one to three days depending on team size and configuration complexity. The five-part setup guide video series covers everything needed to go live with payroll and attendance from scratch.",
  },
  {
    title: "Are there tutorials for specific Waggex features?",
    content:
      "Yes. The Waggex YouTube channel has dedicated tutorials for company setup, shift management, leave management, holiday configuration, employee onboarding, and payslip generation. New feature tutorials are added regularly as the platform grows.",
  },
  {
    title: "Can I share the tutorial videos with my HR team?",
    content:
      "Yes. All Waggex tutorial videos are publicly available on the Waggex YouTube channel. You can share individual video links or the full channel with your HR and finance teams for self-paced learning.",
  },
];

const BASE_URL = import.meta.env.VITE_BASE_URL;

export default function HowtousePage() {
  const [data, setData] = useState([]);
  // const [videoloading, setVideoloading] = useState(true);
  const [isVideoloading, setisVideoLoading] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const { counts, loading } = useHrmsCounts(inView);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    limit: 6,
    total: 0,
    totalPages: 1,
  });

  const fetchData = async (page = 1) => {
    try {
      // setVideoloading(true);
      const res = await axios.get(
        `${BASE_URL}/super-admin-pannel/get-how-to-use`,
        {
          params: {
            page,
            limit: 30,
          },
        },
      );

      setData(res?.data?.data || []);
      setisVideoLoading(res?.data?.data ? true : false);
      setPagination(res?.data?.pagination);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setVideoloading(false);
    }
  };

  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;
    fetchData(1);
  }, []);
  const getYoutubeEmbedUrl = (url) => {
    const videoId = url.match(
      /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/,
    )?.[1];

    return `https://www.youtube.com/embed/${videoId}`;
  };

  const getYoutubeVideoId = (url) => {
    try {
      const parsed = new URL(url);

      if (parsed.hostname.includes("youtu.be")) {
        return parsed.pathname.slice(1);
      }

      if (parsed.hostname.includes("youtube.com")) {
        return parsed.searchParams.get("v");
      }

      return null;
    } catch {
      return null;
    }
  };
  const getYoutubeThumbnail = (url) => {
    const videoId = getYoutubeVideoId(url);
    if (!videoId) return "/images/video-placeholder.webp";

    return `https://i.ytimg.com/vi_webp/${videoId}/mqdefault.webp`;
  };

  return (
    <>
      <SEO
        title="How to Use Waggex | Payroll, Attendance & HRMS Tutorials"
        description="Learn how to use Waggex with step-by-step tutorials covering payroll, attendance, employee management, leave tracking, and HRMS setup."
        canonical="https://www.waggex.com/how-to-use"
      />
      <section className="w-full bg-[#d1dfea] overflow-hidden py-10 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
            {/* Left Content */}
            <div className="text-center lg:text-left">
              <div className="inline-block border border-[#1d3b5c] rounded-xl px-5 py-2 text-[#1d3b5c] text-xs sm:text-sm font-medium">
                How To Use
              </div>
              {/* Heading */}
              <h1 className="mt-8 text-[#10324F] font-bold uppercase tracking-wide text-xl md:text-3xl">
                Everything You Need to Get Started With Waggex
              </h1>

              {/* Description */}
              <p className="service-list-item-text py-4 max-w-md sm:max-w-2xl mx-auto">
                Explore simple tutorials that guide you through account setup,
                company configuration, employee onboarding, attendance tracking,
                leave management, payroll processing, compliance, and payslip
                generation
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <button
                  onClick={() =>
                    (window.location.href =
                      "https://www.youtube.com/watch?v=8n3QWlVKu3o&list=PLSfjI4uTyb-uQT2bEA0d5rPyTbKqX45qm&index=5")
                  }
                  className="w-full sm:w-auto bg-[#10324F] hover:bg-[#10324F] transition-all duration-300 text-white px-14 py-3 rounded-xl shadow-md text-sm sm:text-base font-medium"
                >
                  Watch Tutorials
                </button>

                <button
                  onClick={() =>
                    (window.location.href = "https://www.youtube.com/@Waggex")
                  }
                  className="w-full sm:w-auto border border-[#10324F] text-[#10324F] hover:bg-[#10324F] hover:text-white transition-all duration-300 px-14 py-3 rounded-xl text-sm sm:text-base font-medium"
                >
                  Visit Youtube Channel
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative flex justify-center items-center">
              <div className="w-full max-w-2xl overflow-hidden rounded-2xl border border-white shadow-xl">
                <div className="aspect-video">
                  {/* <iframe
                    className="w-full h-full"
                    src="https://www.youtube-nocookie.com/embed/LxLQJ8V0zBQ"
                    title="intro"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    <iframe width="1307" height="735" src="https://www.youtube.com/embed/LxLQJ8V0zBQ" title="Payroll Software &amp; Attendance App | Best Attendance Software India | Waggex HRMS Intro" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  /> */}
                  {/* <iframe
                    width="556"
                    height="314"
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/LxLQJ8V0zBQ"
                    title="Payroll Software &amp; Attendance App | Best Attendance Software India | Waggex HRMS Intro"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe> */}
                  {/* <img
                    src={getYoutubeThumbnail(
                      "https://www.youtube.com/watch?v=LxLQJ8V0zBQ&t=1s",
                    )}
                    alt="intro video"
                    width="426"
                    height="320"
                    className="w-full h-full hidden md:block object-cover"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                      e.target.src =
                        "https://i.ytimg.com/vi/default/sddefault.jpg";
                    }}
                  /> */}
                  <img
                    src={getYoutubeThumbnail(
                      "https://www.youtube.com/watch?v=LxLQJ8V0zBQ&t=1s",
                    )}
                    alt="intro video"
                    width="300"
                    height="200"
                    loading="lazy"
                    decoding="async"
                    fetchPriority="low"
                    className="w-full h-auto object-cover"
                  />
                  {/* <img
                    src={getYoutubeThumbnail(
                      "https://www.youtube.com/watch?v=LxLQJ8V0zBQ&t=1s",
                    )}
                    alt="intro video"
                    width="362"
                    height="272"
                    className="w-full h-full block md:hidden object-cover"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                      e.target.src =
                        "https://i.ytimg.com/vi/default/sddefault.jpg";
                    }}
                  /> */}
                  <a
                    href="https://www.youtube.com/watch?v=LxLQJ8V0zBQ&t=1s"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Watch waggex on YouTube`}
                    title={`Watch waggex on YouTube`}
                    className="absolute bottom-4 right-4 w-14 h-14 rounded-full bg-[#10324F]/40 border  border-white backdrop-blur-3xl flex items-center justify-center hover:scale-105 transition"
                  >
                    <Play className="text-white ml-1 " />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section ref={ref}>
        <StatsSection counts={counts} loading={loading} />
      </section>
      <TutorialVideosMain videos={data} loading={isVideoloading} />

      <section className="w-full bg-[#F6F9FB] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center max-w-5xl mx-auto">
            <h2 className="text-xl leading-7.5 sm:text-3xl font-roboto font-bold text-[#16324F]">
              Follow This Step-by-Step Waggex Setup Flow
            </h2>
            <p className="mt-3 text-sm leading-6 sm:text-base text-[#10324F] px-2 font-roboto  text-center max-w-3xl mx-auto">
              Use this learning path to understand Waggex in the correct order
              and train your HR team faster.
            </p>
          </div>

          {/* Cards */}
          <div className="mt-8 sm:mt-12 grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {companystepsFeatures.map((item) => (
              <div
                key={item.id}
                style={{
                  boxShadow: `
                  rgb(167 191 210 / 30%) -15px -15px 20px inset,
                  rgb(170 188 202 / 20%) -20px -20px 30px
                `,
                }}
                // style={{
                //   boxShadow: `rgb(167 191 210 / 8%) -15px -15px 20px inset, rgb(170 188 202 / 15%) -20px -20px 30px`,
                // }}
                className="rounded-xl border border-[#E4ECF3] p-6 hover:-translate-y-1 transition-all duration-300"
              >
                {/* Number Box */}
                <div className="flex items-center justify-between mb-5">
                  <div className="w-10 h-9 rounded-md bg-[#10324F] font-roboto text-white flex items-center justify-center text-lg font-bold shadow">
                    {item.id}
                  </div>
                </div>

                {/* Content */}

                <h2 className="font-roboto text-sm sm:text-base font-semibold text-[#10324F] leading-5">
                  {item.title}
                </h2>

                <p className="mt-1 font-roboto text-xs sm:text-sm leading-5 text-[#10324F]">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <TutorialVideos videos={data} loading={isVideoloading} />
      <Suspense fallback={null}>
        <CustomerReviews />
        <HomeFaq
          faq1={Faqs1}
          faq2={Faqs2}
          subtitle="Common questions from businesses learning how to use Waggex for the first time"
        />
        <PayrollBanner
          heading="Manage Compliance & Payroll From One Connected System"
          description="Simplify payroll processing, employee management, and compliance record tracking with one integrated platform built for Indian businesses"
          buttonText="View Payroll Software"
        />
        <AppDownloadCard />
        <ModernizeHR
          heading="Need Help Getting Started With Waggex?"
          description="Our support team is here to help you set up your account, configure features, and get the most out of Waggex"
          buttonText="Contact Support"
          buttonText2="Book a free demo"
          buttonLink="/contact-us"
          buttonLink2="/contact-us"
        />
      </Suspense>
    </>
  );
}
